import React from 'react'
import styles from './createRMG.module.sass'
import CurrencyInfo from './CurrencyInformation'
import { ToastContainer } from 'react-toastify'

const CreateRMGCurrency = ({isChanged, setIsChanged}) => {
  
  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
          <CurrencyInfo isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
        </div>
      </div>
    </>
  )
}

export default CreateRMGCurrency